<template>
  <div class="project">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Project Performance</h4>
      <h1 class="jp-title">{{$t('project.title')}}</h1>
    </div>
    <section>
      <div class="text-left">
        <details-project :project-item="projectData"></details-project>
      </div>
    </section>
  </div>
</template>

<script>
import mainBg from '@/assets/img/environment.png';
import project1 from '@/assets/img/environment.png';
import project2 from '@/assets/img/environment.png';
import project3 from '@/assets/img/environment.png';
import project4 from '@/assets/img/environment.png';
import project5 from '@/assets/img/environment.png';
import project6 from '@/assets/img/environment.png';
import detailsProject from '@/components/detailsProject';
export default {
  name: 'project',
  components: {
    detailsProject
  },
  data () {
    return {
      mainBg: mainBg,
      project1: project1,
      project2: project2,
      project3: project3,
      project4: project4,
      project5: project5,
      project6: project6,
      type: null,
      projectData: {}
    }
  },
  mounted() {
    this.type = this.$route.params.type;
    this.init();
  },
  watch: {
    '$i18n.locale'(val) {
      this.init(val);
    }
  },
  methods: {
    init() {
      if (this.type === 'chemistry') {
        this.projectData = {
          title: this.$t('home.projectName1'),
          content: this.$t('home.projectContent1'),
          item: [
            {
              img: project1,
              name: this.$t('project.project1')
            },
            {
              img: project2,
              name: this.$t('project.project2')
            },
            {
              img: project3,
              name: this.$t('project.project3')
            },
            {
              img: project4,
              name: this.$t('project.project4')
            }
          ]
        } 
      } else if (this.type === 'oil') {
        this.projectData = {
          title: this.$t('home.projectName2'),
          content: this.$t('home.projectContent2'),
          item: [
            {
              img: project3,
              name: this.$t('project.project5')
            },
            {
              img: project4,
              name: this.$t('project.project6')
            }
          ]
        }
      } else if (this.type === 'energy') {
        this.projectData = {
          title: this.$t('home.projectName3'),
          content: this.$t('home.projectContent3'),
          item: [
            {
              img: project4,
              name: this.$t('project.project7')
            },
            {
              img: project6,
              name: this.$t('project.project8')
            }
          ]
        }
      } else if (this.type === 'environment') {
        this.projectData = {
          title: this.$t('home.projectName4'),
          content: this.$t('home.projectContent4'),
          item: [
            {
              img: project5,
              name: this.$t('project.project9')
            },
            {
              img: project2,
              name: this.$t('project.project10')
            }
          ]
        }
      } else if (this.type === 'municipa') {
        this.projectData = {
          title: this.$t('home.projectName5'),
          content: this.$t('home.projectContent5'),
          item: [
            {
              img: project5,
              name: this.$t('project.project11')
            },
            {
              img: project2,
              name: this.$t('project.project12')
            }
          ]
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 2rem;
  }

  .project-introduce {
    width: 1170px;
    margin: 0 auto;
    text-align: left;
    line-height: 2.25rem;
  }

  .jp-project-content {
    font-size: 1.4rem;
    .el-col {
      margin-bottom: 2.5rem;
    }
  }
}

@media (max-width: 768px){
  section {
    .jp-project-content {
      font-size: 1.7rem;

      .el-image {
        max-height: 104px;
      }
    }
    .project-introduce {
      width: 100%;
      line-height: 2.5rem;
      font-size: 1.6rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/project.vue